import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/app/(pages)/case-studies/vision-ai-ml-recognition-mobile-app/page.tsx");
